import { iFacadeApi } from '@andbank-myinvestor/arq/lib/basic-operation';
import i18next, { i18n } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { config } from '../i18n-config';

interface i18nextConfigConfig {
	langCode: () => string;
	language: () => { [id: string]: string };
	changeLanguage: (lang: string) => Promise<{ [id: string]: string }>;
}

const innerStore = {} as i18nextConfigConfig;

const i18nextConfig = ({
	langCode,
	language,
	changeLanguage
}: i18nextConfigConfig): i18n => {
	innerStore.langCode = langCode;
	innerStore.language = language;
	innerStore.changeLanguage = changeLanguage;

	const initialLanguage = language();

	i18next
		.use(initReactI18next) // passes i18n down to react-i18next

		.init({
			...(initialLanguage
				? {
						resources: {
							[langCode()]: {
								translation: initialLanguage
							}
						}
				  }
				: undefined),

			lng: langCode(),

			nsSeparator: false,

			interpolation: {
				escapeValue: false // react already safes from xss
			}
		});

	return i18next;
};

const i18nextChangeLanguage = async (langCode: string) => {
	const language = await innerStore.changeLanguage(langCode);
	localStorage.setItem('lang', langCode);
	// Dispatch custom event to notify other parts of the app about language change
	window.dispatchEvent(new Event('languageChanged'));
	i18next.addResourceBundle(langCode, 'translation', language, false, true);
	await i18next.changeLanguage(langCode);
	return i18next;
};

const i18nextInitializer = async (api: iFacadeApi) => {
	i18nextConfig({
		langCode: api.lang.currentLangCode,
		language: api.lang.currentLanguage,
		changeLanguage: api.lang.changeLanguage
	});

	if (!config.fetchLanguage) i18nextChangeLanguage(api.lang.currentLangCode());
};

export { i18nextConfig, i18nextChangeLanguage, i18nextInitializer };
